module.exports = __webpack_public_path__ + "static/media/PayBy.aa3024cc.svg";